import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "organization-details",
  class: "d-flex flex-fill edit-page-40"
}
const _hoisted_2 = { class: "card border-0 background-fb" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "edit-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Organization Details")
], -1)
const _hoisted_4 = {
  class: "card-body overflow-auto",
  id: "card-body"
}
const _hoisted_5 = { id: "organization-draft" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Name:", -1)
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "Created At:", -1)
const _hoisted_11 = {
  id: "connector-table",
  class: "margin-top-10"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "Connectors", -1)
const _hoisted_13 = { class: "pagination-wrapper" }
const _hoisted_14 = {
  id: "user-table",
  class: "margin-top-10"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", null, "Users", -1)
const _hoisted_16 = { class: "pagination-wrapper" }
const _hoisted_17 = { class: "card-footer footer" }
const _hoisted_18 = { class: "float-right" }
const _hoisted_19 = { class: "loader-div-40" }
const _hoisted_20 = ["src"]

import { computed, onBeforeMount, ref } from "vue";
import { cloneDeep } from "lodash-es";
import { ElTable, ElTableColumn, ElButton, ElPagination } from "element-plus";
import { getOrganization } from "@/organization/services/organization.service";
import { currentRoute, router } from "@/core/router";
import { hasPermission } from "@/core/auth";
import { ASSETS_BASE_URL, DEFAULT_LOGO } from "@/core/logo";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationDetails',
  setup(__props) {

const organization = ref({
  connectors: [],
  organizationRoles: [],
});

const id = ref("");

const headerStyle = ref({
  color: "#363636",
  borderBottomColor: "#a9d4fa",
  fontSize: "15px",
  fontWeight: "bolder !important",
  backgroundColor: "#fbfbfb",
});

const rowStyle = ref({
  cursor: "pointer",
  backgroundColor: "#fbfbfb",
});

const pageLoading = ref(false);

const perPageConnectors = ref(5);

const currentPageConnectors = ref(1);

const numberOfConnectors = computed(() =>
  organization.value.connectors ? organization.value.connectors.length : 0
);

const numberOfPagesConnectors = computed(() => {
  if (numberOfConnectors.value) {
    return Math.ceil(numberOfConnectors.value / perPageConnectors.value);
  }
  return 0;
});

const connectorTableData = computed(() => {
  if (organization.value.connectors) {
    if (numberOfPagesConnectors.value === 1) {
      return organization.value.connectors;
    }
    const start = (currentPageConnectors.value - 1) * perPageConnectors.value;
    const end = currentPageConnectors.value * perPageConnectors.value;
    return organization.value.connectors.slice(start, end);
  }
  return [];
});

const perPageUsers = ref(5);

const currentPageUsers = ref(1);

const numberOfUsers = computed(() =>
  organization.value.organizationRoles
    ? organization.value.organizationRoles.length
    : 0
);

const numberOfPagesUsers = computed(() => {
  if (numberOfUsers.value) {
    return Math.ceil(numberOfUsers.value / perPageUsers.value);
  }
  return [];
});

const userTableData = computed(() => {
  if (organization.value.organizationRoles) {
    if (numberOfPagesUsers.value === 1) {
      return organization.value.organizationRoles;
    }
    const start = (currentPageUsers.value - 1) * perPageUsers.value;
    const end = currentPageUsers.value * perPageUsers.value;
    return organization.value.organizationRoles.slice(start, end);
  }
  return [];
});

function convertDate(dateStr) {
  const milliseconds = Date.parse(dateStr);
  const date = new Date(milliseconds);
  return date.toLocaleDateString();
}

onBeforeMount(async () => {
  pageLoading.value = true;
  id.value = currentRoute.value.params.id as string;
  if (id.value) {
    await getOrganization(id.value).then((response) => {
      if (response) {
        organization.value = cloneDeep(response);
      }
    });
  }
  pageLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(organization.value.name), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createTextVNode(" " + _toDisplayString(convertDate(organization.value.createdAt)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_unref(ElTable), {
              data: connectorTableData.value,
              style: {"width":"100%","background-color":"#fbfbfb"},
              "header-cell-style": headerStyle.value,
              "row-style": rowStyle.value
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElTableColumn), {
                  label: "Name",
                  prop: "name",
                  width: "auto"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(ElTableColumn), {
                  label: "Spec Id",
                  prop: "specId",
                  width: "auto"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.connectorSpecId), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "header-cell-style", "row-style"]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_unref(ElPagination), {
                small: "",
                "page-size": perPageConnectors.value,
                style: {"width":"auto"},
                background: "",
                "hide-on-single-page": "",
                total: numberOfConnectors.value,
                "current-page": currentPageConnectors.value,
                "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPageConnectors).value = $event)),
                layout: "prev, pager, next"
              }, null, 8, ["page-size", "total", "current-page"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_unref(ElTable), {
              data: userTableData.value,
              style: {"width":"100%","background-color":"#fbfbfb"},
              "header-cell-style": headerStyle.value,
              "row-style": rowStyle.value
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElTableColumn), {
                  label: "Name",
                  prop: "name",
                  width: "auto"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.user.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(ElTableColumn), {
                  label: "Role",
                  prop: "Role",
                  width: "auto"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.role.authority), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "header-cell-style", "row-style"]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_unref(ElPagination), {
                small: "",
                "page-size": perPageUsers.value,
                style: {"width":"auto"},
                background: "",
                "hide-on-single-page": "",
                total: numberOfUsers.value,
                "current-page": currentPageUsers.value,
                "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((currentPageUsers).value = $event)),
                layout: "prev, pager, next"
              }, null, 8, ["page-size", "total", "current-page"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_unref(ElButton), {
            class: "btn-oneTeg3",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/organizations')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Back ")
            ]),
            _: 1
          }),
          (_unref(hasPermission)('ORGANIZATIONS.LIST.EDIT'))
            ? (_openBlock(), _createBlock(_unref(ElButton), {
                key: 0,
                class: "btn-oneTeg2",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push('/organizations/edit/' + id.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Edit ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, !pageLoading.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_19, [
      _createElementVNode("img", {
        src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
        alt: "Loading...",
        class: "loader-logo-40"
      }, null, 8, _hoisted_20)
    ], 512), [
      [_vShow, pageLoading.value]
    ])
  ]))
}
}

})